(function () {
  var instances = new WeakMap();

  var shouldAnimate = function (section) {
    return (
      section.classList.contains('animation') &&
      !document.documentElement.classList.contains('prefers-reduced-motion')
    );
  };

  var queryAll = function (root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  };

  var setDelayOffsets = function (section, selectors, offsetStart) {
    var offset = offsetStart || 0;

    selectors.forEach(function (selector) {
      queryAll(section, selector).forEach(function (item) {
        item.style.setProperty('--delay-offset-multiplier', offset);
        offset += 1;
      });
    });

    return offset;
  };

  var getMediaQuery = function (querySize) {
    return getComputedStyle(document.documentElement)
      .getPropertyValue('--media-' + querySize)
      .trim();
  };

  var watchIntersection = function (section) {
    var mediaQuery = getMediaQuery('above-720');
    var margin = window.matchMedia(mediaQuery).matches ? 200 : 100;
    var threshold = Math.min(margin / section.offsetHeight, 0.5);

    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          section.classList.add('is-visible');
          observer.disconnect();
        }
      },
      { threshold: threshold }
    );

    observer.observe(section);

    return {
      destroy: function () {
        observer.disconnect();
      },
    };
  };

  var init = function (section) {
    if (!shouldAnimate(section)) {
      return null;
    }

    setDelayOffsets(section, [
      '.animation--container-header > *',
      '.animation--container > *',
      '.animation--item',
      '.animation--container-footer > *',
    ]);

    return watchIntersection(section);
  };

  var destroy = function (section) {
    var instance = instances.get(section);

    if (instance) {
      instance.destroy();
      instances.delete(section);
    }

    section.classList.remove('is-visible');
  };

  var initAll = function (scope) {
    var container = scope || document;

    container.querySelectorAll('[data-section-type="custom-blogs-tabs"]').forEach(function (section) {
      destroy(section);

      var instance = init(section);

      if (instance) {
        instances.set(section, instance);
      }
    });
  };

  var destroyAll = function (scope) {
    var container = scope || document;

    container.querySelectorAll('[data-section-type="custom-blogs-tabs"]').forEach(function (section) {
      destroy(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();
